class CustomScroll {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }
  event() {
    const scrollWraps = document.querySelectorAll('.js-custom-scroll');

    scrollWraps.forEach((item) => {
      const barWrap = item.querySelector('.js-custom-scroll__bar-wrap');
      const bar = item.querySelector('.js-custom-scroll__bar');
      const wrap = item.querySelector('.js-custom-scroll__content');
    
      function updateBar() {
        const wrapHeight = wrap.clientHeight;
        const scrollHeight = wrap.scrollHeight;
        const scrollTop = wrap.scrollTop;
        const barWrapHeight = barWrap.clientHeight;
    
        // スクロール可能範囲
        const scrollableHeight = scrollHeight - wrapHeight;
    
        // ✅ 現時点での「正しいバー高さ」を常に再計算
        const barHeight = Math.max(barWrapHeight * (wrapHeight / scrollHeight), 20);
        bar.style.height = `${barHeight}px`;
    
        // ✅ バーの位置をスクロール量に応じて更新
        const maxBarTop = barWrapHeight - barHeight;
        const barTop = scrollableHeight > 0 ? (scrollTop / scrollableHeight) * maxBarTop : 0;
        bar.style.transform = `translateY(${barTop}px)`;
      }
    
      // ✅ 初期状態もセット（スクロール前でも正しい長さ）
      updateBar();
    
      // ✅ イベント監視（スクロール・リサイズ・内容変化）
      wrap.addEventListener('scroll', updateBar);
      window.addEventListener('resize', updateBar);
    
      // ✅ DOM更新後（画像などで高さ変化が起きた時にも追従）
      const observer = new MutationObserver(updateBar);
      observer.observe(wrap, { childList: true, subtree: true });
    });
    
  }
}
